module.exports = __webpack_public_path__ + "img/cab.16b11027.png";